import { connect } from 'react-redux'
import { compose } from 'redux'
import getData from '../../../functions/getData'
import { FLYER_DATA } from '../../../constants/state'
import hasSingleMovie from '../../../hoc/hasSingleMovie'
import toJS from '../../../hoc/toJS'
import { IMAGE, MOVIE } from '../../../constants/itemTypes'
import ListItemMovieContainer from './ListItemMovieContainer'
import ListItemImageContainer from './ListItemImageContainer'

const imageItemMapStateToProps = (state, ownProps) => ({
    imgData: getData(state, [FLYER_DATA, 'imageElements', 'items', ownProps.imgId])
})

const ImageContainer = ({itemType, imgData, pathnameEdit, onDelete}) => {
    return <ListItemImageContainer
        imgKey='payload'
        itemType={itemType}
        itemData={imgData}
        additionalClass=''
        isSelected={false}
        pathnameEdit={pathnameEdit}
        onDelete={onDelete}
    />
}

const MovieContainer = ({itemType, movieData, pathnameEdit, onDelete}) => {
    return <ListItemMovieContainer 
        itemType={itemType}
        itemData={movieData}
        additionalClass=''
        isSelected={false}
        pathnameEdit={pathnameEdit}
        onDelete={onDelete}
    />
}

const enhanceMovie = compose(
    hasSingleMovie(),
    toJS()
)

const enhanceImage = compose(
    connect(imageItemMapStateToProps, null),
    toJS()
)

const EnhancedMovieContainer = enhanceMovie(MovieContainer)
const EnhancedImageContainer = enhanceImage(ImageContainer)

const ListItemGridImageContainer = ({
    itemData, 
    pathnameEdit,
    onDelete
}) => {
    if(!itemData || !itemData.itemType) {
        return ''
    }

    if(MOVIE === itemData.itemType )  {
        return <EnhancedMovieContainer 
            itemType={MOVIE}
            movieId={itemData.itemId}
            pathnameEdit={pathnameEdit}
            onDelete={onDelete}
        />
    } else if(IMAGE === itemData.itemType) {
        return <EnhancedImageContainer
            itemType={IMAGE}
            imgId={itemData.itemId}
            pathnameEdit={pathnameEdit}
            onDelete={onDelete}
        />
    } else {
        return ''
    }
}

export default ListItemGridImageContainer